import React, { FC, useMemo } from 'react';
import { CopyIcon } from '@raisin/components-lib';
import { useT } from '@transifex/react';
import * as S from './styles';
import productPageMessages from '../../ProductPage/messages';

const ProductPageStepper: FC = () => {
  const t = useT();
  const componentProps = useMemo(
    () => ({
      uid: '',
      title: '',
      hide_title: true,
      className: 'steps',
      items: [
        {
          svg: (
            <S.StepContainer data-testid="step">
              <S.StepNumber>{t(productPageMessages.affiliateStepsFirstStepIconText)}</S.StepNumber>
            </S.StepContainer>
          ),
          title: t(productPageMessages.affiliateStepsFirstStepTitle),
          body: t(productPageMessages.affiliateStepsFirstStepDescription),
        },
        {
          svg: (
            <S.StepContainer data-testid="step">
              <S.StepNumber>{t(productPageMessages.affiliateStepsSecondStepIconText)}</S.StepNumber>
            </S.StepContainer>
          ),
          title: t(productPageMessages.affiliateStepsSecondStepTitle),
          body: t(productPageMessages.affiliateStepsSecondStepDescription),
        },
        {
          svg: (
            <S.StepContainer data-testid="step">
              <S.StepNumber>{t(productPageMessages.affiliateStepsThirdStepIconText)}</S.StepNumber>
            </S.StepContainer>
          ),
          title: t(productPageMessages.affiliateStepsThirdStepTitle),
          body: t(productPageMessages.affiliateStepsThirdStepDescription),
        },
      ],
    }),
    [t],
  );
  return (
    <S.StepsContainer>
      <CopyIcon {...componentProps} />
    </S.StepsContainer>
  );
};

export default ProductPageStepper;
